import * as angular from 'angular';
import * as _ from 'lodash';
import { StateService } from '@uirouter/angularjs';

import { engineer, master, operator } from '../../../common/Roles';
import { ApplicationUser, ApplicationUserViewModel, ComponentDefinition, ICharm } from '../../../models';
import { DashboardThumbnailWidget } from '../../../widgets';
import { guidEmpty } from '../../../common/constants';
import { IapplicationUserService, IAuthenticationService, ICurrentApplicationService, IStoreService } from '../../../services';
import { IHomeService, MapHomeStoreToThis } from '../home.service';
import { Store, StoreElement } from '../../../stateManagement';

class HomeStateController implements angular.IComponentController, MapHomeStoreToThis {
    dashboards: DashboardThumbnailWidget[];
    dataInputTiles: ICharm[];
    filteredTiles: ICharm[];
    isDashboardDataLoaded: boolean;
    isOperator: boolean;
    isMaster: boolean;
    isEngineer: boolean;
    tiles: ICharm[];
    users: ApplicationUserViewModel[];

    private _currentUser: ApplicationUser;
    private _unsubscribe: () => void;
    private _dashboardLoaded: angular.IDeferred<DashboardThumbnailWidget[]>;
    private _storeLoaded: angular.IDeferred<any>;

    static $inject = [
        '$q',
        '$state',
        'applicationUserService',
        'authenticationService',
        'currentApplicationService',
        'homeService',
        'storeService',
    ];
    constructor(
        private _$q: angular.IQService,
        private _$state: StateService,
        private _applicationUserService: IapplicationUserService,
        private _authenticationService: IAuthenticationService,
        private _currentApplicationService: ICurrentApplicationService,
        private _homeService: IHomeService,
        private _storeService: IStoreService,
    ) {
        this.tiles = [];
        this._dashboardLoaded = this._$q.defer();
        this._storeLoaded = this._$q.defer();
    }

    $onInit() {
        // Initial load of tiles
        const storeElements = [
            StoreElement.ConnectionPoints,
            StoreElement.ConnectionPointsStatuses,
            StoreElement.Dashboards,
            StoreElement.Groups,
            StoreElement.Tags,
            StoreElement.ValidationPageConfigurations,
            StoreElement.Variables,
            StoreElement.Application,
            StoreElement.Layout
        ];

        this._unsubscribe = this._storeService.registerAsync(
            undefined,
            {
                callback: store => this.refresh(store),
                elements: storeElements
            }
        );

        this._dashboardLoaded.promise
            .then(dashboards => this._homeService.refreshQualityWidgetValues(dashboards))
            .then(() => this.isDashboardDataLoaded = true);

        this._storeLoaded.promise
            .then((store) => this._homeService.refreshDataInputCharms(store))
            .then((data) => {
                this.dataInputTiles = data.sort((a, b) => a.text.localeCompare(b.text));
            });

        this.checkIfOperator();
    }

    $onDestroy() {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }

    selectItem(thumbnail: DashboardThumbnailWidget, $event: angular.IAngularEvent) {
        this._$state.go('dashboard', { dashboardName: thumbnail.guid });
    }

    private refresh(store: Store) {
        const results = this._homeService.refreshCharms(this.tiles, store);
        this.tiles = results.tiles;
        this.filteredTiles = this.tiles.filter(tile => tile.isVisible);
        this.dashboards = results.dashboards;
        if (store.dashboards.isLoaded && results.dashboards.length > 0) {
            this._dashboardLoaded.resolve(results.dashboards);
        }
        if (store.groups.isLoaded) {
            this._storeLoaded.resolve(store);
        }
    }

    private checkIfOperator() {
        const config = this._currentApplicationService.getApplicationConfiguration();
        const defaultUser: ApplicationUserViewModel = {
            userId: guidEmpty,
            name: '',
            roles: [],
            displayName: '',
            guid: guidEmpty,
            title: '',
            firstName: '',
            lastName: '',
            company: '',
            initials: '',
            phoneNumber: '',
            email: '',
            isSuperAdmin: undefined
        };

        const currentUserName = this._authenticationService.authentication.userName;

        this._applicationUserService
            .getUsers(config.guid)
            .then(data => {
                this.users = [defaultUser].concat(data);
                this._currentUser = _.find(this.users, u => u.name === currentUserName);
                this.isOperator = this._currentUser.roles.indexOf(operator) > -1;
                this.isEngineer = this._currentUser.roles.indexOf(engineer) > -1;
                this.isMaster = this._currentUser.roles.indexOf(master) > -1;
            });
    }
}

export const wtHomeState: ComponentDefinition = {
    componentId: 'wtHomeState',
    controller: HomeStateController,
    template: require('./homeState.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};